// video-testimonials.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vdt').forEach(initVideoCarousel);
});

function initVideoCarousel(root) {
  const track = root.querySelector('.vdt__track');
  const cards = root.querySelectorAll('.vdt__card');
  const dots = root.querySelectorAll('.vdt__dot');
  const prevBtn = root.querySelector('[data-direction="prev"]');
  const nextBtn = root.querySelector('[data-direction="next"]');
  if (!track || cards.length === 0) return;

  // mute/unmute on tap
  root.querySelectorAll('.vdt__mute').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const video = btn.previousElementSibling?.tagName === 'VIDEO'
        ? btn.previousElementSibling
        : btn.closest('.vdt__card').querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      btn.textContent = video.muted ? '🔇' : '🔊';
    });
  });
  root.querySelectorAll('.vdt__card').forEach(card => {
    card.addEventListener('click', () => {
      const video = card.querySelector('video');
      const btn = card.querySelector('.vdt__mute');
      if (!video) return;
      video.muted = !video.muted;
      if (btn) btn.textContent = video.muted ? '🔇' : '🔊';
    });
  });

  function currentIndex() {
    const trackRect = track.getBoundingClientRect();
    let closestIndex = 0;
    let closestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.getBoundingClientRect().left - trackRect.left);
      if (dist < closestDist) { closestDist = dist; closestIndex = i; }
    });
    return closestIndex;
  }

  function scrollToIndex(index) {
    const card = cards[index];
    if (!card) return;
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function updateUI() {
    const idx = currentIndex();
    dots.forEach((d, i) => d.classList.toggle('vdt__dot--active', i === idx));
    if (prevBtn) prevBtn.disabled = idx === 0;
    if (nextBtn) nextBtn.disabled = idx === cards.length - 1;
  }

  prevBtn?.addEventListener('click', () => scrollToIndex(Math.max(0, currentIndex() - 1)));
  nextBtn?.addEventListener('click', () => scrollToIndex(Math.min(cards.length - 1, currentIndex() + 1)));

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateUI, 100);
  });

  updateUI();
}
